import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import { calculators } from '../data/calculators';
const CalculatorPage = () => {
    const { calculatorId } = useParams();
    const calculator = calculators.find((c) => c.id === calculatorId);
    if (!calculator) {
        return (_jsx(Container, { maxWidth: "md", children: _jsx(Typography, { variant: "h5", children: "Calculator not found" }) }));
    }
    const CalculatorComponent = calculator.component;
    return (_jsxs(Container, { maxWidth: "md", children: [_jsxs(Box, { sx: { mb: 3 }, children: [_jsx(Typography, { variant: "h4", gutterBottom: true, children: calculator.name }), _jsx(Typography, { variant: "body1", color: "text.secondary", children: calculator.description })] }), _jsx(CalculatorComponent, {})] }));
};
export default CalculatorPage;
